import { useEffect } from 'react'

// Close dropdown when clicking outside
export function useClickOutsideEffect(
  closeJobDropdownOpen: boolean,
  closeJobDropdownRef: React.RefObject<HTMLDivElement>,
  closeJobButtonRef: React.RefObject<HTMLButtonElement>,
  setCloseJobDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (closeJobDropdownOpen && closeJobDropdownRef.current && !closeJobDropdownRef.current.contains(event.target as Node)) {
        if (closeJobButtonRef.current && !closeJobButtonRef.current.contains(event.target as Node)) {
          setCloseJobDropdownOpen(false)
        }
      }
    }

    if (closeJobDropdownOpen) {
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside)
      }, 0)

      return () => {
        clearTimeout(timeoutId)
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }
  }, [closeJobDropdownOpen, closeJobDropdownRef, closeJobButtonRef, setCloseJobDropdownOpen])
}
